import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AbsColor } from './constants';

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            main: AbsColor.Blue1
        },
        secondary: {
            main: AbsColor.Red1
        },
        error: {
            main: AbsColor.Red2
        }
    },
    typography: {
        fontFamily: 'Montserrat, Arial, sans-serif' // Specify the custom font
    }
});

const AppTheme = ({ children }: { children?: React.ReactNode }) => {
    return (
        <>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </>
    );
};

export default AppTheme;
